import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';

@Component({
  selector: 'lib-tab-group',
  imports: [],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupComponent<T> {
  tabs = input.required<Tab<T>[]>();
  indexSelected = output<T>();
  currentSelectedIndex = signal<T | undefined>(undefined);

  tabsModifiedEffect = effect(() => {
    this.tabs().some(tab => {
      if (!tab.disabled) {
        this.currentSelectedIndex.set(tab.value);
        this.indexSelected.emit(tab.value);
        return true;
      } else {
        return false;
      }
    });
  });

  itemClicked(index: T) {
    if (this.tabs().find(tab => tab.value === index)?.disabled) return;
    this.currentSelectedIndex.set(index);
    this.indexSelected.emit(index);
  }
}

export class Tab<T> {
  public title: string;
  public value: T;
  public disabled: boolean = false;

  constructor(title: string, value: T, disabled: boolean = false) {
    this.title = title;
    this.value = value;
    this.disabled = disabled;
  }
}
